import { z } from "zod";

/**
 * Mendefinisikan struktur untuk satu entitas booking.
 * Setiap properti divalidasi dengan tipe data yang spesifik.
 */
const BookingSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    room_type_id: z.nullable(z.string().uuid()),
    room_id: z.nullable(z.string().uuid()),
    rate_plan_id: z.nullable(z.string().uuid()),
    checkin_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
    checkout_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
    status: z.nullable(z.string()).optional(),
    mark: z.nullable(z.string()).optional(),
    payment_type: z.nullable(z.string()).optional(),
    created_at: z.string(),
    updated_at: z.string(),
    source: z.string(),
    invoice_number: z.string(),
    invoice_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
    customer_name: z.string(),
    customer_surname: z.nullable(z.string()),
    customer_email: z.nullable(z.string()),
    voucher_number: z.string().nullable(),
    ota_name: z.string(),
    ota_primary_color: z.nullable(z.string().regex(/^#([0-9A-Fa-f]{6})$/)).optional(),
    ota_secondary_color: z.nullable(z.string().regex(/^#([0-9A-Fa-f]{6})$/)).optional(),
    agent_color: z.nullable(z.string().regex(/^#([0-9A-Fa-f]{6})$/)).optional(),
    total_payments: z.nullable(z.string()).optional(),
    down_payment: z.nullable(z.string()).optional(),
    due_payment: z.nullable(z.string()).optional(),
    total_rate: z.nullable(z.string()).optional(), // Perbaikan dari Tring() menjadi string()
});

/**
 * Mendefinisikan struktur untuk seluruh envelope (bungkus) respons API.
 * Terdiri dari metadata dan array dari data booking.
 */
const DataCalendarResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(BookingSchema),
});

// Ekspor skema untuk digunakan di tempat lain
export { DataCalendarResponseSchema, BookingSchema };

// Ekspor tipe TypeScript yang di-infer dari skema Zod
export type DataCalendarResponse = z.infer<typeof DataCalendarResponseSchema>;
export type BookingType = z.infer<typeof BookingSchema>;